// 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ start
import { FC, useEffect } from 'react';
import { Button } from 'antd';
import { useAppDispatch } from 'hooks';
import { Modal } from 'components';
import SectionStyled from './styles';
import { saveInfo } from './slice';

interface Props {
  new_education_user_name: string;
  education_user_name: string;
  user_name: string;
  visible: boolean;
  onCancel: (cancel: boolean) => void;
  onOk: (cancel: boolean) => void;
}

const Kakunin: FC<Props> = ({
  new_education_user_name,
  education_user_name,
  user_name,
  visible,
  onCancel,
  onOk,
}) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(
      saveInfo({
        new_education_user_name: new_education_user_name,
        education_user_name: education_user_name,
        user_name: user_name,
      })
    );
  }, [new_education_user_name, education_user_name, user_name]);
  const onBackButton = () => {
    onCancel(false);
  };
  const onOkButton = () => {
    onOk(false);
  };
  return (
    <Modal visible={visible} footer={false} destroyOnClose={false} width={300}>
      <SectionStyled>
        <div className="group-div">
          <span className="group-span">新規教育実施者：{new_education_user_name}</span>
        </div>
        <div className="group-div">
          <span className="group-span">送り出し教育実施者：{education_user_name}</span>
        </div>
        <div className="group-div">
          <span className="group-span">受講者：{user_name}</span>
        </div>
        <div className="message">
          <span className="group-span">上記の内容でお間違えないでしょうか。</span>
        </div>
        <div className="ant-modal-footer">
          <Button className="button-back" onClick={onBackButton}>
            キャンセル
          </Button>
          <Button className="button-ok" onClick={onOkButton}>
            OK
          </Button>
        </div>
      </SectionStyled>
    </Modal>
  );
};

export default Kakunin;

// 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ end
